import { Button } from 'antd';
import { BlockOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const quoteCommand = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).toggleBlockquote().run()
    : editor.chain().focus().toggleBlockquote().run();

const Quote = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('blockquote') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<BlockOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => quoteCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="QUOTE" defaultMessage="Quote" />
        </div>
      )}
    </Button>
  );
};

export default Quote;
